import React from 'react';
import cx from 'classnames';
import { isLayoutMock, isLocalTest, toggleLayoutMock } from 'appConstants';
import styles from './styles.module.scss';

const DevPanel = () => {
  const prodEnv = localStorage.getItem('useProdEnv') === 'true' ? 'Prod' : 'Dev';
  const layoutMock = isLayoutMock();
  const switchHandle:() => void = () => {
    localStorage.setItem('useProdEnv', prodEnv === 'Dev' ? 'true' : 'false');
    window.location.reload();
  };

  return isLocalTest ? (
    <>
      <div
        className={styles.devEnvSwitcher}
        onClick={switchHandle}
      >
        <div className={styles.hidden}>{prodEnv[0]}</div>
        <div className={styles.hover}>{prodEnv === 'Dev' ? 'Stage API' : 'Prod API'}</div>
      </div>
      <div
        className={cx(styles.devEnvSwitcher, styles.mockSwitcher, styles.mockSwitcherOffset)}
        onClick={toggleLayoutMock}
      >
        <div className={styles.hidden}>{layoutMock ? 'M' : 'A'}</div>
        <div className={styles.hover}>
          {layoutMock ? 'Макет' : 'API контент'}
        </div>
      </div>
    </>
  ) : (
    <div
      className={styles.devEnvSwitcherWarning}
    >
      {prodEnv === 'Prod' && (
        <b>
          Включена БОЕВАЯ БАЗА ДАННЫХ. (Не отправляйте формы с сайта).
        </b>
      )}
    </div>
  );
};

export default DevPanel;
